/**
 *
 * Base
 *
 */

import 'fancybox';

( function( $ ) {
	'use strict';

	/**
	 *
	 * Header Scroll
	 *
	 */
	$( window ).scroll( function() {

		var scroll = $( window ).scrollTop();
		if( 150 <= scroll ) {
			$( 'html' ).addClass( 'is-scrolled' );
		}
		if( 149 >= scroll ) {
			$( 'html' ).removeClass( 'is-scrolled' );
		}

	} );

	/**
	 *
	 * Smooth scroll on click
	 *
	 */
	$( 'a[href^="#"]' ).on( 'click', function ( e ) {

		e.preventDefault();

		var target = this.hash;
		var $target = $( target );

		$( 'html, body' ).stop().animate( {
			'scrollTop': $target.offset().top
		}, 900, 'swing', function () {
			window.location.hash = target;
		} );

	} );

	/**
	 *
	 * Instantiate Fancybox
	 *
	 */

	$( '[data-fancybox]' ).fancybox( {
		focus: false,
		buttons: [ 'close' ],
		animationEffect: 'zoom-in-out',
	} );
	$.fancybox.defaults.hash = false;


} )( jQuery );
